export default {"src":"/_next/static/media/Viewup App Icon.1242c502.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};